// RegisterPage renders the same unified auth component as LoginPage.
// The tab state is derived from the URL path (/register shows Create Account tab).
// Both routes must use the same component reference so React Router
// reuses the instance and preserves form state during tab switches.
import LoginPage from './LoginPage';

export default LoginPage;
